/**
 * @desc 分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.CertMainSkuResponseDto>
>;
export function request(
  params: API.basics.certMainSku.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/certMainSku/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
